const TwoColContainer = ({ children, testid }) => {
  return (
    <div className='grid-cols-12 gap-1 md:grid' data-cy={testid}>
      {children}
    </div>
  );
};
export default TwoColContainer;
